<template>
  <div class="container">

    <el-collapse v-model="menu" accordion>

      <el-collapse-item v-if="canAccess('finance')" name="settings" title="Settings">
        <h2>Finance Settings</h2>
        <el-row :gutter="24">

          <el-col :span="24">
            <el-card>
              <div slot="header" class="clearfix">
                <h3>Invoicing</h3>
              </div>
              <el-form>
                Select Sharer: <select-sharer v-model="telcoId" />

                <el-row  v-for="(inv, index) in settings.invoicing" :key="inv.id" :gutter="8">

                <el-col :span="8">
                  <check-box v-if="telcoId" v-model="inv.send" :disabled="!canEdit">{{inv.type}}</check-box>
                </el-col>
<!--
                <el-col :span="10">
                <el-form-item>
                  <el-cascader
                     :ref="'casc' + inv.id"
                     v-if="inv.send"
                     :props="{expandTrigger: 'hover'}"
                     v-model="settings.invoicing[index].timing"
                     :options="options"
                      :disabled="!canEdit">
                   </el-cascader>
                   <span v-else>
                     &nbsp;
                   </span>
                 </el-form-item>
                </el-col>
-->
                 <el-col :span="6" align="right">
                   <el-form-item>    <!-- @click="inv.callback"  -->
                     <el-button icon="fa fa-clock" v-if="inv.send" :type="inv.color" :disabled="!telcoId" @click="inv.callback">Run Now</el-button>
                   </el-form-item>
                </el-col>
              </el-row>

              <check-box label="e-Mail" label-width="12rem" v-model="settings.sendPDF" :disabled="true">Send PDF to Recipient</check-box>

              </el-form>
            </el-card>
          </el-col>

          <el-col :span="24">
            <br />
            <el-card>
              <div slot="header" class="clearfix">
                <h3>Settings</h3>
              </div>
              <el-row>
                <el-form :props="settings" label-width="10rem">
                  <el-form-item label="Tax Name">
                    <el-input v-model="settings.taxName" :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item label="Tax Rate">
                    <el-input type="number" v-model="settings.taxRate" :disabled="!canEdit">
                      <span slot="append">%</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Tax Number">
                    <el-input v-model="settings.taxNumber" :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item label="Standard Tems">
                      <el-input type="number" v-model="settings.terms" :disabled="!canEdit">
                        <span slot="append">days</span>
                      </el-input>
                  </el-form-item>

                </el-form>
              </el-row>
            </el-card>
          </el-col>

        </el-row>

      </el-collapse-item>

      <el-collapse-item v-if="canAccess('finance|management')"  name="table" title="Agreements">

          <agreements-table />

      </el-collapse-item>

      <el-collapse-item name="rates" title="Rate Tables">

        <el-tabs type="card">
          <el-tab-pane label="Sharers" lazy>
            <rates-table  />
          </el-tab-pane>

          <el-tab-pane label="Tenancy" lazy>
            <rates-table view="tenancy" />
          </el-tab-pane>

          <el-tab-pane label="Utility" lazy>
            <rates-table view="utility" />
          </el-tab-pane>

        </el-tabs>

      </el-collapse-item>

      <el-collapse-item v-if="canAccess('finance')" name="builder" title="Agreements Builder">

          <agreements-builder />

      </el-collapse-item>

    </el-collapse>



  </div>
</template>

<script>

import axios from '@/lib/axiosClient'

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import AgreementsTable from '@/components/finance/rates/AgreementsTable'
import RatesTable from '@/components/finance/rates/RatesTable'
import SelectSharer from '@/components/atoms/selects/SelectSharer'

import AgreementsBuilder from '@/components/settings/AgreementsBuilder'

export default {
  mixins: [PostMixins, NumberMixins],

  components: {
    AgreementsBuilder,
    AgreementsTable,
    SelectSharer,
    RatesTable
  },

  methods: {
    runSharerInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        this.send(this, '/api/invoice/sharers/' + this.telcoId, null, this.success, 'Sharer\'s Invoice Job Started', this.fail, axios.put)
      }

    },

    runAdvanceInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        this.send(this, '/api/invoice/advance/' + this.telcoId, null, this.success, 'Advance Invoice Job Started', this.fail, axios.put)
      }

    },

    runUtilityInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        this.send(this, '/api/invoice/utility/' + this.telcoId, null, this.success, 'Utility Invoice Job Started', this.fail,  axios.put)
      }

    },

    success (response) {
      this.$alert('Invoice Job created, the invoices will be scheduled for creation during the early hours of the morning.')
    },

    fail (response) {
      this.$alert ('Failed')
    }

  },

  data () {
    return {
      menu: this.canAccess('admin') ? 'rates' : 'settings',
      canEdit: this.isManager('finance'),
      telcoId: null,
      timing: [],
      settings: {
        taxName: settings.taxName,
        taxRate: settings.taxRate,
        taxNo: '',
        terms: 30,
        sendPDF: false,
        invoicing: [
          {id: 1, type: 'Sharing Invoice', color: 'success', send: true, timing: [], callback: this.runSharerInvoices},
          {id: 2, type: 'Utility Advance Invoice', color: 'primary', send: true, timing: [], callback: this.runAdvanceInvoices},
          {id: 3, type: 'Utility Sharing Invoice', color: 'warning', send: true, timing: [], callback: this.runUtilityInvoices}
        ]
      },
      options: [{
        value: 'exact',
        label: 'Exact Day',
        children: [
        ]
      }, {
        value: 'first',
        label: 'First',
        children: [
          {value: 'mon', label: 'Monday'},
          {value: 'tue', label: 'Tuesday'},
          {value: 'wed', label: 'Wednesday'},
          {value: 'thu', label: 'Thursday'},
          {value: 'fri', label: 'Friday'},
          {value: 'sat', label: 'Satday'},
          {value: 'sun', label: 'Sunday'}
        ]
      }, {
        value: 'last',
        label: 'Last',
        children: [
          {value: 'mon', label: 'Monday'},
          {value: 'tue', label: 'Tuesday'},
          {value: 'wed', label: 'Wednesday'},
          {value: 'thu', label: 'Thursday'},
          {value: 'fri', label: 'Friday'},
          {value: 'sat', label: 'Satday'},
          {value: 'sun', label: 'Sunday'}
        ]
      }]
    }
  }, // data
  created () {
    let days = this.options[0].children

    for (let i = 0; i < 30; i++) {
      days.push({value: '' + (i + 1), label: this.addSuffix(i + 1) + ' of the month'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// FinanceSettings.vue?494fd479